export default "__VITE_ASSET__D637kww$__"